import { DriverPlants } from '../driver-plants';
import { User } from './user';

export class Driver {
    id:number = 0;
    name:string = '';
    last_name:string = '';
    address:string = '';
    type:string = 'Operador';
    phone_number:string = '';
    emergency_number : string = '';
    curp:string = '';
    born_date:Date = new Date();
    licence_type:string = ''; 
    licence_date:Date = new Date(); 
    licence_number:string = ''; 
    medic_date:Date = null; 
    no_account:string = null; 
    contracted_date:Date = new Date(); 
    uncontracted_date:Date = null; 
    uncontracted_description:string = null;
    active:boolean = false;
    avatar:string = '';
    license : string = '';
    certificate : string = '';
    updated_at: any;
    last_user_updated_id: number = null;
    last_user_updated: string = null;
    plants: DriverPlants[] = [];
}
